import { useQuery } from "@tanstack/react-query";
import { onlineUsersQueryOptions } from "@/shared/api/onlineUsers";

interface OnlineUsersIndicatorProps {
  className?: string;
}

export const OnlineUsersIndicator: React.FunctionComponent<
  OnlineUsersIndicatorProps
> = ({ className }: OnlineUsersIndicatorProps) => {
  const { data } = useQuery(onlineUsersQueryOptions());

  if (!data || !Number.isFinite(data.count) || data.count < 0) return null;

  return (
    <output className={className} aria-live="polite">
      現在{Math.floor(data.count)}人くらいが見てます。
    </output>
  );
};
